import {COLORS} from '@/styles/colors';

export const CHECKBOX_SX = {
  // Nudge the box up so it aligns with the first line of a multi-line label
  paddingTop: '2px',
  '&.Mui-checked': {
    color: COLORS.ON_SURFACE_1,
  },
  '&:not(.Mui-checked)': {
    color: COLORS.SILVER_SAND,
  },
  '&.MuiFormControlLabel-label': {textAlign: 'left'},
};

export const FORM_CONTROL_LABEL_SX = {
  // Keep the checkbox at the top-left when the label wraps to multiple lines
  alignItems: 'flex-start',
  '& .MuiFormControlLabel-label': {
    textAlign: 'left',
  },
};
